// ======================= PLANT 3 JOB ORDER HANDLER =======================

import { HttpMethod } from "@/types/https";
import { apiCall } from "../base";
import { ENDPOINT } from "../endpoint";

export const JobOrdersDynamic = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `JobOrdersDynamic_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.JOB_ORDERS_DYNAMIC,
        method: HttpMethod.GET
      })
  };
};

export const JobOrdersDetailDynamic = (params: any) => {
  const { id, ...restParams } = params;
  const stringParams = JSON.stringify(params);
  return {
    name: `JobOrdersDetailDynamic_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params: restParams,
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/${id}`,
        method: HttpMethod.GET
      })
  };
};

export const UpdateJobOrdersDynamic = () => {
  return {
    name: "UpdateJobOrdersDynamic",
    handle: ({ body, id }: any): Promise<any> => {
      return apiCall<any>({
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/${id}`,
        method: HttpMethod.PUT,
        body
      });
    }
  };
};

export const AddJobOrderDynamic = () => {
  return {
    name: "AddJobOrderDynamic",
    handle: (body: any): Promise<any> => {
      return apiCall<any>({
        url: ENDPOINT.JOB_ORDERS_DYNAMIC,
        method: HttpMethod.POST,
        body
      });
    }
  };
};

// ATTRIBUTE

export const JobOrdersDynamicAttribute = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `JobOrdersDynamic_attributes_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/attributes`,
        method: HttpMethod.GET
      })
  };
};

export const JobOrdersDynamicAttributeById = (id: string) => {
  return apiCall<any>({
    url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/attribute/${id}`,
    method: HttpMethod.GET
  });
};

export const AddJobOrderDynamicAttribute = () => {
  return {
    name: "AddJobOrderDynamicAttribute",
    handle: (body: any): Promise<any> => {
      return apiCall<any>({
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/attribute`,
        method: HttpMethod.POST,
        body
      });
    }
  };
};

export const UpdateJobOrderDynamicAttribute = () => {
  return {
    name: "UpdateJobOrderDynamicAttribute",
    handle: ({ body, id }: any): Promise<any> => {
      return apiCall<any>({
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/attribute/${id}`,
        method: HttpMethod.PUT,
        body
      });
    }
  };
};

export const JobOrdersDynamicAttributeDataType = () => {
  return {
    name: "JobOrdersDynamicAttributeDataType",
    handle: (): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/attributes/data-types`,
        method: HttpMethod.GET
      })
  };
};

export const DeleteJobOrderDynamicAttribute = () => {
  return {
    name: "DeleteJobOrderDynamicAttribute",
    handle: ({
      id,
      confirmLabel
    }: {
      id: number;
      confirmLabel: string;
    }): Promise<any> => {
      return apiCall<any>({
        url: `${ENDPOINT.JOB_ORDERS_DYNAMIC}/attributes/${id}`,
        method: HttpMethod.DELETE,
        params: { confirmLabel }
      });
    }
  };
};

export const UpdateJobOrderRanks = () => {
  return {
    name: "UpdateJobOrderRanks",
    handle: (body: {
      workspaceId: number;
      updates: {
        jobOrderIds: number[];
        afterJobOrderId: number | null;
        beforeJobOrderId: number | null;
      };
    }): Promise<any> => {
      return apiCall<any>({
        url: ENDPOINT.JOB_ORDERS_RANKS,
        method: HttpMethod.POST,
        body
      });
    }
  };
};

export const CompleteJobOrder = () => {
  return {
    name: "CompleteJobOrder",
    handle: ({
      id,
      isComplete
    }: {
      id: number;
      isComplete: boolean;
    }): Promise<any> => {
      return apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER}/${id}/complete`,
        method: HttpMethod.PUT,
        body: { isComplete }
      });
    }
  };
};
